/* jshint undef: true, unused: true */
/* globals require */

var FoBuComponentFactory = require('./fobu-component-factory');

module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      inputChildren    = componentSettings.inputChildren;

  Object.keys(inputChildren).map(function(key, idx, keys) {
    inputChildren[key]  .isChildComponent = true;
    var child = foBu.createItem(componentSettings.inputChildren[key]);

    child.classList.add('combo--child');
    if (idx === 0) {
      child.classList.add('combo--first-child');
    } else if (idx === keys.length - 1) {
      child.classList.add('combo--last-child');
    }

    foBu.manageEventListener(child, 'change', function () {
      foBu.updateComboHiddenField(element, inputChildren);
      foBu.validation.validateElement(foBu.settings.uid, element.foBuSettings.attributes.id);
    });

    wrapper.appendChild(child);
  });

  if (typeof componentSettings.init === 'function') {
    componentSettings.init(wrapper, foBu);
  }

  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
